import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api, { mxn } from "@/lib/api";
import { ArrowLeft, Clock, Trophy, PackageOpen, Sprout, ArrowRight } from "lucide-react";

function daysUntil(dateStr) {
  const t = new Date(); t.setHours(0, 0, 0, 0);
  return Math.max(0, Math.round((new Date(`${dateStr}T00:00:00`) - t) / 86400000));
}

function build({ soon, leaders, surplus, stats }) {
  const items = [];
  [...(soon || [])].sort((a, b) => (a.available_date || "").localeCompare(b.available_date || "")).forEach((a) => {
    items.push({ icon: Clock, accent: "#2563EB", title: `${a.quantity} ${a.name.toLowerCase()} se liberan en ${daysUntil(a.available_date)} días.`, subtitle: a.project_name, cta: { label: "Ver activos", to: "/search" } });
  });
  if (leaders?.[0]) items.push({ icon: Trophy, accent: "#D97706", title: `${leaders[0].name} lidera el ranking de reutilización.`, subtitle: `${leaders[0].points.toLocaleString()} puntos`, cta: { label: "Ver proyecto", to: `/projects/${leaders[0].project_id}/impact` } });
  (surplus || []).forEach((s) => {
    items.push({ icon: PackageOpen, accent: "#16A34A", title: `${s.quantity} ${s.unit} de ${s.name.toLowerCase()} disponibles.`, subtitle: s.project_region === "centro" ? "Zona Centro" : "Material sobrante", cta: { label: "Explorar", to: "/surplus" } });
  });
  const saved = stats?.gamification?.total_money_saved;
  if (saved) items.push({ icon: Sprout, accent: "#059669", title: `Gracias a la reutilización evitamos ${mxn(saved).replace(/\.00$/, "")} en compras.`, subtitle: "Impacto de sustentabilidad", cta: { label: "Ver impacto", to: leaders?.[0] ? `/projects/${leaders[0].project_id}/impact` : "/leaderboard" } });
  return items;
}

export default function Novedades() {
  const nav = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => {
    Promise.all([
      api.get("/assets", { params: { availability: "available_soon", is_surplus: false } }).then((r) => r.data).catch(() => []),
      api.get("/leaderboard", { params: { sort: "points" } }).then((r) => r.data).catch(() => []),
      api.get("/assets", { params: { is_surplus: true } }).then((r) => r.data).catch(() => []),
      api.get("/dashboard/stats").then((r) => r.data).catch(() => null),
    ]).then(([soon, leaders, surplus, stats]) => setItems(build({ soon, leaders, surplus, stats })));
  }, []);

  return (
    <div className="max-w-3xl mx-auto space-y-6" data-testid="novedades-page">
      <Link to="/" className="inline-flex items-center text-xs uppercase tracking-[0.18em] text-[#5C6A7D] hover:text-[#0A2540]"><ArrowLeft size={14} className="mr-1" /> Lobby</Link>
      <div>
        <div className="text-[10px] uppercase tracking-[0.25em] text-[#16A34A] font-bold">Novedades</div>
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold text-[#0A2540] tracking-tighter mt-1">Todo lo que está pasando hoy.</h1>
      </div>
      <div className="space-y-3">
        {items.length === 0 && <div className="bg-white border border-[#E2E8F0] rounded-2xl p-10 text-center text-sm text-[#5C6A7D]">Sin novedades por ahora.</div>}
        {items.map((n, i) => (
          <button key={i} onClick={() => nav(n.cta.to)} className="w-full text-left bg-white border border-[#E2E8F0] rounded-2xl p-5 flex items-center gap-4 transition-all duration-300 hover:-translate-y-0.5 hover:border-[#16A34A]/30 hover:shadow-[0_12px_30px_rgba(22,163,74,0.10)]" data-testid={`novedad-${i}`}>
            <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0" style={{ background: `${n.accent}14`, color: n.accent }}><n.icon size={22} strokeWidth={1.75} /></div>
            <div className="flex-1 min-w-0">
              <div className="font-semibold text-[#0A2540]">{n.title}</div>
              <div className="text-xs uppercase tracking-[0.14em] text-[#5C6A7D] mt-0.5">{n.subtitle}</div>
            </div>
            <span className="inline-flex items-center gap-1 text-sm font-semibold shrink-0" style={{ color: n.accent }}>{n.cta.label} <ArrowRight size={15} /></span>
          </button>
        ))}
      </div>
    </div>
  );
}
